import {
  BLOG_AVATAR01,
  BLOG_AVATAR02,
  BLOG_AVATAR03,
  BLOG_AVATAR04,
  BLOG_AVATAR05,
  BLOG_AVATAR06,
  BLOG_IMG01,
  BLOG_IMG02,
  BLOG_IMG03,
  H2_BLOG_IMG01,
  H2_BLOG_IMG02,
  H2_BLOG_IMG03,
  H3_BLOG_IMG01,
  H3_BLOG_IMG02,
  H3_BLOG_IMG03,
  H3_BLOG_IMG04,
  H3_BLOG_IMG05,
  H3_BLOG_IMG06,
  H4_BLOG_IMG01,
  H4_BLOG_IMG02,
  H4_BLOG_IMG03,
  RC_POST01,
  RC_POST02,
  RC_POST03,
  RC_POST04,
} from "../lib/assets";

export const BLOGS_LIST_TWO = [
  {
    id: 1,
    href: "/blog-details",
    src: H2_BLOG_IMG01,
    src2: H3_BLOG_IMG01,
    src3: H4_BLOG_IMG01,
    src4: BLOG_IMG01,
    tag: "Development",
    tag2: "Car Insurance",
    tag3: "Development",
    tagHref: "/blog",
    title: "Meet AutoManage, the best AI management tools",
    subtitle:
      "Everything you need to start building area atching presence for your business.",
    avatar: BLOG_AVATAR01,
    author: "Kat Doven",
    author2: "Admin",
    createdAt: "22 Jan, 2023",
  },
  {
    id: 2,
    href: "/blog-details",
    src: H2_BLOG_IMG02,
    src2: H3_BLOG_IMG02,
    src3: H4_BLOG_IMG02,
    src4: BLOG_IMG02,
    tag: "Business",
    tag2: "Home Insurance",
    tag3: "Development",
    tagHref: "/blog",
    title: "Meet AutoManage, the best AI management tools",
    subtitle:
      "Everything you need to start building area atching presence for your business.",
    avatar: BLOG_AVATAR01,
    author: "Kat Doven",
    author2: "Admin",
    createdAt: "22 Jan, 2023",
  },
  {
    id: 3,
    href: "/blog-details",
    src: H2_BLOG_IMG03,
    src2: H3_BLOG_IMG03,
    src3: H4_BLOG_IMG03,
    src4: BLOG_IMG03,
    tag: "Tax Advisory",
    tag2: "Family Insurance",
    tag3: "Development",
    tagHref: "/blog",
    title: "Meet AutoManage, the best AI management tools",
    subtitle:
      "Everything you need to start building area atching presence for your business.",
    avatar: BLOG_AVATAR01,
    author: "Kat Doven",
    author2: "Admin",
    createdAt: "22 Jan, 2023",
  },
];

export const BLOG_CATEGORIES = [
  {
    label: "Business",
    value: "02",
  },
  {
    label: "Consulting",
    value: "08",
  },
  {
    label: "Corporate",
    value: "05",
  },
  {
    label: "Design",
    value: "02",
  },
  {
    label: "Fashion",
    value: "11",
  },
  {
    label: "Marketing",
    value: "12",
  },
];

export const RECENT_BLOGS = [
  {
    id: 1,
    createdAt: "22 Jan, 2023",
    href: "/blog-details",
    src: RC_POST01,
    title: "Whale Be Raised Must Be In A Month",
  },
  {
    id: 2,
    createdAt: "22 Jan, 2023",
    href: "/blog-details",
    src: RC_POST02,
    title: "Whale Be Raised Must Be In A Month",
  },
  {
    id: 3,
    createdAt: "22 Jan, 2023",
    href: "/blog-details",
    src: RC_POST03,
    title: "Whale Be Raised Must Be In A Month",
  },
  {
    id: 4,
    createdAt: "22 Jan, 2023",
    href: "/blog-details",
    src: RC_POST04,
    title: "Whale Be Raised Must Be In A Month",
  },
];

export const BLOG_TAGS = ["Finance", "Consultancy", "Data", "Agency", "Travel"];

export const BLOG_PAGE_LIST = [
  {
    id: 1,
    createdAt: "22 Jan, 2023",
    title: "Meet AutoManage, the best AI management tools",
    subtitle:
      "Everything You Need To Start Building Area Atching Presence For Your Business.",
    tag: "Development",
    author: "Kat Doven",
    src: H3_BLOG_IMG01,
    authorSrc: BLOG_AVATAR01,
    href: "/blog-details",
    tagHref: "/blog",
  },
  {
    id: 2,
    createdAt: "22 Jan, 2023",
    title: "Meet AutoManage, the best AI management tools",
    subtitle:
      "Everything You Need To Start Building Area Atching Presence For Your Business.",
    tag: "Business",
    author: "Floyd Miles",
    src: H3_BLOG_IMG02,
    authorSrc: BLOG_AVATAR02,
    href: "/blog-details",
    tagHref: "/blog",
  },
  {
    id: 3,
    createdAt: "22 Jan, 2023",
    title: "Meet AutoManage, the best AI management tools",
    subtitle:
      "Everything You Need To Start Building Area Atching Presence For Your Business.",
    tag: "Tax Advisory",
    author: "Bessie Cooper",
    src: H3_BLOG_IMG03,
    authorSrc: BLOG_AVATAR03,
    href: "/blog-details",
    tagHref: "/blog",
  },
  {
    id: 4,
    createdAt: "22 Jan, 2023",
    title: "Meet AutoManage, the best AI management tools",
    subtitle:
      "Everything You Need To Start Building Area Atching Presence For Your Business.",
    tag: "Business",
    author: "Devon Lane",
    src: H3_BLOG_IMG04,
    authorSrc: BLOG_AVATAR04,
    href: "/blog-details",
    tagHref: "/blog",
  },
  {
    id: 5,
    createdAt: "22 Jan, 2023",
    title: "Meet AutoManage, the best AI management tools",
    subtitle:
      "Everything You Need To Start Building Area Atching Presence For Your Business.",
    tag: "Consultancy",
    author: "Annette Black",
    src: H3_BLOG_IMG05,
    authorSrc: BLOG_AVATAR05,
    href: "/blog-details",
    tagHref: "/blog",
  },
  {
    id: 6,
    createdAt: "22 Jan, 2023",
    title: "Meet AutoManage, the best AI management tools",
    subtitle:
      "Everything You Need To Start Building Area Atching Presence For Your Business.",
    tag: "Finance",
    author: "Eleanor Pena",
    src: H3_BLOG_IMG06,
    authorSrc: BLOG_AVATAR06,
    href: "/blog-details",
    tagHref: "/blog",
  },
];
